<button mat-button type="button" *ngIf="!hideNoteButton" (click)="toggleFlyout()" class="notes-opener linq-opener-button" title="{{buttonTitle}}">
	<mat-icon>sticky_note_2</mat-icon>
	<span *ngIf="!hideButtonText">Notes</span>
</button>
<ng-template cdk-portal>
	<div class="linq-drawer-content">
		<header class="linq-drawer-header">
			<h3 class="linq-heading">{{flyoutHeaderTitle}}</h3>
			<button class="linq-drawer-header__close linq-button-close-lg" (click)="close()">
				<mat-icon>clear</mat-icon>
			</button>
		</header>
		<div class="linq-drawer-inner-content linq-drawer-inner-content--spaced flyout-inner-container">
			<form (ngSubmit)="notesForm.valid && createNote()" #notesForm="ngForm" *ngIf="!readOnly">
				<mat-form-field>
					<mat-label>Add a new note</mat-label>
					<textarea name="createNoteText" #createNoteText="ngModel" [(ngModel)]="noteText" matInput requiredNoWhitespace></textarea>
					<mat-error *ngIf="createNoteText.errors?.required">Text is required</mat-error>
				</mat-form-field>
				<button type="submit" mat-raised-button color="primary" class="pull-right" [disabled]="notesForm.invalid">Save</button>
				<div class="clearfix"></div>
			</form>
			<hr *ngIf="!readOnly" />
			<div *ngFor="let noteEntity of notes$|async; trackById" class="note-wrapper">
				<div *ngIf="!isEditing(noteEntity.Id)">
					<div class="pull-right" *ngIf="showNotesMenu(noteEntity)">
						<button mat-icon-button [matMenuTriggerFor]="noteMenu" aria-label="Actions">
							<mat-icon>more_vert</mat-icon>
						</button>
						<mat-menu #noteMenu="matMenu">
							<button mat-menu-item (click)="editNote(noteEntity.Id)">Edit</button>
							<button mat-menu-item (click)="deleteNote(noteEntity.Id)">Delete</button>
						</mat-menu>
					</div>
					<div class="preserve-line-breaks">{{ noteEntity.NoteText }}</div>
				</div>
				<form *ngIf="isEditing(noteEntity.Id)" (ngSubmit)="editNotesForm.valid && updateNote(noteEntity, editNoteText.value)"
					#editNotesForm="ngForm">
					<mat-form-field>
						<mat-label>Update note</mat-label>
						<textarea name="editNoteText" #editNoteText="ngModel" [ngModel]="noteEntity.NoteText" matInput
							requiredNoWhitespace></textarea>
						<mat-error *ngIf="editNoteText.errors?.required">Text is required</mat-error>
					</mat-form-field>
					<button type="button" mat-button color="warn" (click)="cancelEditing()">Cancel</button>
					<button type="submit" mat-raised-button color="primary" class="pull-right" [disabled]="editNotesForm.invalid">Save</button>
					<div class="clearfix"></div>
				</form>
				<div class="note-byline">
					{{ noteEntity.CreatedBy }} &#64; {{ getLocalTime(noteEntity.CreatedOn) | date: 'short' }}
					<em *ngIf="noteEntity.ModifiedOn" [title]="'Last Modified On ' + (getLocalTime(noteEntity.ModifiedOn) | date: 'short')">
						(edited)</em>
				</div>
			</div>
			<shared-no-data-available *ngIf="(notes$|async).length === 0" message="No notes yet">
			</shared-no-data-available>
		</div>
	</div>
</ng-template>
